(() => {
  if (window.mellooaCartBaselineInstalled) {
    return;
  }

  window.mellooaCartBaselineInstalled = true;

  const cartNoteMediaQuery = window.matchMedia('(max-width: 699px)');
  let discountSubmitGuardForm = null;
  let discountSubmitGuardTimer = null;

  const normalizeCartDiscounts = (cart) => {
    const discountApplications = cart?.cart_level_discount_applications;

    if (!Array.isArray(discountApplications)) {
      return;
    }

    discountApplications.forEach((discountApplication) => {
      if (
        discountApplication?.discount_application == null &&
        Number.isFinite(Number(discountApplication?.total_allocated_amount))
      ) {
        discountApplication.discount_application = {
          total_allocated_amount: Number(discountApplication.total_allocated_amount),
        };
      }
    });
  };

  const updateFreeShippingBars = (cart) => {
    if (!Array.isArray(cart?.items)) {
      return;
    }

    const shippingItemsTotal = cart.items
      .filter((item) => item.requires_shipping)
      .reduce((total, item) => total + Number(item.final_line_price || 0), 0);
    const cartDiscountTotal = (cart.cart_level_discount_applications || []).reduce(
      (total, discountApplication) =>
        total +
        Number(
          discountApplication.total_allocated_amount ??
            discountApplication.discount_application?.total_allocated_amount ??
            0,
        ),
      0,
    );

    document.querySelectorAll('free-shipping-bar').forEach((freeShippingBar) => {
      freeShippingBar.setAttribute('total-price', String(shippingItemsTotal - cartDiscountTotal));
      syncFreeShippingProgress(freeShippingBar);
    });
  };

  const syncFreeShippingProgress = (freeShippingBar) => {
    const progressBar = freeShippingBar.querySelector('progress-bar');
    const status = freeShippingBar.querySelector('[role="status"]');
    const maximum = Number(progressBar?.getAttribute('aria-valuemax'));
    const totalPrice = Number(freeShippingBar.getAttribute('total-price'));

    if (!progressBar || !Number.isFinite(maximum) || maximum <= 0) {
      return;
    }

    const boundedValue = Math.min(maximum, Math.max(0, Number.isFinite(totalPrice) ? totalPrice : 0));
    progressBar.setAttribute('aria-valuenow', String(boundedValue));
    progressBar.setAttribute('aria-valuetext', status?.textContent.trim() || '');
  };

  const enhanceCartSurfaces = () => {
    enhanceDiscountErrors();
    enhanceCartNoteDisclosures();
    enhanceQuietfitAddons();
    document.querySelectorAll('free-shipping-bar').forEach(syncFreeShippingProgress);
  };

  const enhanceQuietfitAddons = () => {
    document.querySelectorAll('[data-mellooa-quietfit-addon]').forEach((addon) => {
      if (addon.dataset.mellooaQuietfitReady === 'true') {
        return;
      }

      addon.dataset.mellooaQuietfitReady = 'true';
      addon.addEventListener('click', (event) => {
        const swatch = event.target.closest('[data-mellooa-quietfit-swatch]');

        if (!swatch || !addon.contains(swatch)) {
          return;
        }

        addon.querySelectorAll('[data-mellooa-quietfit-swatch]').forEach((otherSwatch) => {
          otherSwatch.setAttribute('aria-pressed', String(otherSwatch === swatch));
        });

        const variantInput = addon.querySelector('[data-mellooa-quietfit-variant-input]');
        const selection = addon.querySelector('[data-mellooa-quietfit-selection]');
        const selectedDot = addon.querySelector('[data-mellooa-quietfit-selected-dot]');
        const image = addon.querySelector('[data-mellooa-quietfit-image]');
        const addButton = addon.querySelector('[data-mellooa-quietfit-add]');
        const variantId = swatch.dataset.variantId || '';

        if (variantInput) {
          variantInput.value = variantId;
        }
        if (selection) {
          selection.textContent = swatch.dataset.variantTitle || '';
        }
        if (selectedDot && swatch.dataset.swatchColor) {
          selectedDot.style.setProperty('--mellooa-addon-swatch', swatch.dataset.swatchColor);
        }
        if (image && swatch.dataset.variantImage) {
          image.src = swatch.dataset.variantImage;
          image.removeAttribute('srcset');
          image.alt = `${swatch.dataset.variantTitle || 'Selected'} Mellooa QuietFit Earplugs`;
        }
        if (addButton) {
          addButton.disabled = swatch.dataset.variantAvailable !== 'true';
        }
        if (variantId) {
          addon.querySelectorAll('[data-mellooa-quietfit-detail-link]').forEach((detailLink) => {
            const productUrl = detailLink.dataset.productUrl || '/products/mellooa-quietfit-earplugs';
            const separator = productUrl.includes('?') ? '&' : '?';
            detailLink.href = `${productUrl}${separator}variant=${encodeURIComponent(variantId)}`;
          });
        }

        const picker = swatch.closest('details');
        if (picker) {
          picker.open = false;
        }
      });
    });
  };

  const enhanceDiscountErrors = () => {
    document
      .querySelectorAll('.mellooa-cart-surface cart-discount-banner')
      .forEach((discountBanner) => {
        discountBanner.setAttribute('role', 'alert');
        discountBanner.setAttribute('aria-live', 'assertive');
        discountBanner.setAttribute('aria-atomic', 'true');
      });

    document
      .querySelectorAll('.mellooa-cart-surface cart-discount-field')
      .forEach((discountField) => {
        const input = discountField.querySelector('input:not([type="hidden"])');
        const banner = discountField.closest('.cart-discount')?.querySelector('cart-discount-banner');

        if (!input || !banner) {
          return;
        }

        input.setAttribute('enterkeyhint', 'done');
        banner.id ||= `${input.id || 'mellooa-cart-discount'}-error`;
      });
  };

  const setCartNoteExpanded = (disclosure, expanded) => {
    const toggle = disclosure.querySelector('[data-mellooa-cart-note-toggle]');
    const panel = disclosure.querySelector('[data-mellooa-cart-note-panel]');

    if (!toggle || !panel) {
      return;
    }

    toggle.setAttribute('aria-expanded', String(expanded));
    panel.hidden = !expanded;
  };

  const enhanceCartNoteDisclosures = () => {
    document
      .querySelectorAll('.shopify-section--main-cart [data-mellooa-cart-note-disclosure]')
      .forEach((disclosure) => {
        if (disclosure.dataset.mellooaCartNoteReady === 'true') {
          return;
        }

        const toggle = disclosure.querySelector('[data-mellooa-cart-note-toggle]');

        if (!toggle) {
          return;
        }

        disclosure.dataset.mellooaCartNoteReady = 'true';
        setCartNoteExpanded(disclosure, !cartNoteMediaQuery.matches);
        toggle.addEventListener('click', () => {
          setCartNoteExpanded(disclosure, toggle.getAttribute('aria-expanded') !== 'true');
        });
      });
  };

  const syncCartNoteDisclosuresToViewport = () => {
    document
      .querySelectorAll('.shopify-section--main-cart [data-mellooa-cart-note-disclosure]')
      .forEach((disclosure) => setCartNoteExpanded(disclosure, !cartNoteMediaQuery.matches));
  };

  const getDiscountParts = (discountField) => {
    const input = discountField?.querySelector('input:not([type="hidden"])');
    const banner = discountField?.closest('.cart-discount')?.querySelector('cart-discount-banner');
    return { input, banner };
  };

  const removeDescriptionToken = (input, token) => {
    const tokens = (input.getAttribute('aria-describedby') || '')
      .split(/\s+/)
      .filter((value) => value && value !== token);

    if (tokens.length > 0) {
      input.setAttribute('aria-describedby', tokens.join(' '));
    } else {
      input.removeAttribute('aria-describedby');
    }
  };

  const clearDiscountError = (discountField) => {
    const { input, banner } = getDiscountParts(discountField);

    if (!input || !banner) {
      return;
    }

    banner.hidden = true;
    input.removeAttribute('aria-invalid');

    if (banner.id) {
      removeDescriptionToken(input, banner.id);
    }
  };

  const handleDiscountInput = (event) => {
    const discountField = event.target?.closest?.('.mellooa-cart-surface cart-discount-field');

    if (discountField) {
      clearDiscountError(discountField);
    }
  };

  const handleDiscountKeydown = (event) => {
    if (event.key !== 'Enter' || event.isComposing) {
      return;
    }

    const discountField = event.target?.closest?.('.mellooa-cart-surface cart-discount-field');
    const { input } = getDiscountParts(discountField);

    if (!discountField || event.target !== input) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();

    if (discountField.getAttribute('aria-busy') === 'true') {
      return;
    }

    clearDiscountError(discountField);

    if (input.value.trim() === '') {
      input.focus();
      return;
    }

    discountSubmitGuardForm = input.closest('form');
    window.clearTimeout(discountSubmitGuardTimer);
    discountSubmitGuardTimer = window.setTimeout(() => {
      discountSubmitGuardForm = null;
    }, 0);

    let changeObserved = false;
    input.addEventListener('change', () => {
      changeObserved = true;
    }, { once: true });
    input.blur();

    if (!changeObserved) {
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  };

  const handleDiscountFormSubmit = (event) => {
    if (!discountSubmitGuardForm || event.target !== discountSubmitGuardForm) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();
    discountSubmitGuardForm = null;
  };

  const handleQuietfitPreviewSubmit = (event) => {
    const previewForm = event.target?.closest?.('[data-mellooa-quietfit-preview-form]');

    if (!previewForm) {
      return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();
    const message = previewForm
      .closest('[data-mellooa-quietfit-addon]')
      ?.querySelector('[data-mellooa-quietfit-preview-message]');

    if (message) {
      message.hidden = false;
    }
  };

  const handleDiscountError = (event) => {
    const discountField = event.target?.closest?.('.mellooa-cart-surface cart-discount-field');
    const { input, banner } = getDiscountParts(discountField);

    if (!input || !banner) {
      return;
    }

    window.requestAnimationFrame(() => {
      document
        .querySelectorAll('.mellooa-cart-surface cart-discount-banner')
        .forEach((otherBanner) => {
          otherBanner.hidden = otherBanner !== banner;
        });

      banner.hidden = false;
      input.setAttribute('aria-invalid', 'true');

      const descriptionTokens = new Set(
        (input.getAttribute('aria-describedby') || '').split(/\s+/).filter(Boolean),
      );
      descriptionTokens.add(banner.id);
      input.setAttribute('aria-describedby', [...descriptionTokens].join(' '));

      try {
        input.focus({ preventScroll: true });
      } catch {
        input.focus();
      }
    });
  };

  document.addEventListener(
    'cart:change',
    (event) => {
      const cart = event.detail?.cart;
      normalizeCartDiscounts(cart);
      updateFreeShippingBars(cart);
    },
    true,
  );

  document.addEventListener('keydown', handleDiscountKeydown, true);
  document.addEventListener('submit', handleDiscountFormSubmit, true);
  document.addEventListener('submit', handleQuietfitPreviewSubmit, true);
  document.addEventListener('input', handleDiscountInput, true);
  document.addEventListener('cart:discount:error', handleDiscountError, true);

  const freeShippingObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.target instanceof HTMLElement && mutation.target.matches('free-shipping-bar')) {
        syncFreeShippingProgress(mutation.target);
      }
    });
  });

  freeShippingObserver.observe(document.documentElement, {
    attributes: true,
    attributeFilter: ['total-price'],
    subtree: true,
  });

  document.addEventListener('cart-drawer:refreshed', enhanceCartSurfaces);
  document.addEventListener('shopify:section:load', enhanceCartSurfaces);

  if (typeof cartNoteMediaQuery.addEventListener === 'function') {
    cartNoteMediaQuery.addEventListener('change', syncCartNoteDisclosuresToViewport);
  } else {
    cartNoteMediaQuery.addListener(syncCartNoteDisclosuresToViewport);
  }

  enhanceCartSurfaces();
})();
